import {http_request} from "../../../httpConfig";
import {v4 as uuidv4} from "uuid";


export const loadedProjectList = {
    namespaced: true,
    state: {
        uploadedProjects: [],
        numberLoadedItems: 3,
        waitingResponseToProjectsRequest: false,
        allUploaded: false,
        mask: ''
    },
    mutations: {
        DELETE_PROJECT_BY_UUID:(state, uuid) => {
            let indexProject = state.uploadedProjects.findIndex(project => project.guid === uuid);
            if (indexProject !== -1) {
                console.log(state.uploadedProjects.splice(indexProject, 1));
            }
        },
        UPLOADED_PROJECTS:(state, newProjects) => {
            if (newProjects.length !== 0)
                state.uploadedProjects = state.uploadedProjects.concat(newProjects);
            else
                state.allUploaded = true;
        },
        MASK: (state, value) => {
            state.mask = value;
        },
        CLEAR_UPLOADED_PROJECTS: (state) => {
            state.uploadedProjects.splice(0);
            state.allUploaded = false;
        }
    },
    getters: {
        UPLOADED_PROJECTS: state => state.uploadedProjects,
        PROJECT_BY_UUID: state => uuid => {
            return state.uploadedProjects.find(project => project.guid === uuid);
        }
    },
    actions: {
        COPY_ACTIVE_PROJECT: async function (context, nameNewProject) {
            const activeProjectGUID = context.rootState.route.params.projectUUID;
            const newProjectGUID = uuidv4();
            const projectForCopy = context.getters.PROJECT_BY_UUID(activeProjectGUID);
            if (!projectForCopy)
                return;

            let projectCopy = JSON.parse(JSON.stringify(projectForCopy.data_json));
            projectCopy.name = nameNewProject;
            const templateCopyProject = {
                data_json: projectCopy,
                guid: newProjectGUID,
                customers: [],
                open_read: false,
                open_write: false,
                user_request: false
            };
            return await http_request.post('/save_project', {[newProjectGUID]:templateCopyProject})
                .then((request) => {
                    console.log(request.data);
                    return newProjectGUID;
                })
                .catch((error) => {
                    console.error(error);
                });


            // context.commit(`${newProjectGUID}/NAME`, nameNewProject);
            // return newProjectGUID;
        },
        GET_DATA_PROJECT: function (context) {
            if (context.state.waitingResponseToProjectsRequest || context.state.allUploaded)
                return;

            const mask = context.state.mask.trim();
            let dataForSend = {
                part: {
                    from: context.state.uploadedProjects.length,
                    count: context.state.numberLoadedItems
                },
                user_request: false
            };
            if(mask.length !== 0){
                dataForSend.find = {
                    mask,
                    field: "data_json->>'name'"
                };
            }
            return dataForSend;
        },
        GET_PROJECTS:async function (context, inputData) {
            const dataForSend = await context.dispatch('GET_DATA_PROJECT');
            if(!dataForSend || context.state.waitingResponseToProjectsRequest)
                return;

            context.state.waitingResponseToProjectsRequest = true;
            // console.log(dataForSend);
            await http_request.post('/get_project', dataForSend)
                .then((request) => {
                    // console.log('projects111', request);
                    context.commit('UPLOADED_PROJECTS', request.data.projects);
                })
                .catch((error) => {
                    console.log(error);
                    console.log(error.response);
                });

            context.state.waitingResponseToProjectsRequest = false;
        },
        GET_PROJECTS_LITE:async function (context, inputData) {
            const dataForSend = await context.dispatch('GET_DATA_PROJECT');
            if(!dataForSend)
                return;
            context.state.waitingResponseToProjectsRequest = true;
            console.log(dataForSend);
            await http_request.post('/get_project_lite', dataForSend)
                .then((request) => {
                    console.log(request.data);
                    context.commit('UPLOADED_PROJECTS', request.data.projects);
                })
                .catch((error) => {
                    console.log(error);
                    console.log(error.response);
                });

            context.state.waitingResponseToProjectsRequest = false;
        }
    }
};
